import React from 'react';

import LetterTile from './letter-tile.jsx';

import { sanitizeUrlForMime } from '../lib/utils.js';

export default class QQNavRail extends React.PureComponent {
  render() {
    const avatar = this.props.avatar ?
      this.props.tinode.authorizeURL(sanitizeUrlForMime(this.props.avatar, 'image')) : true;
    const active = this.props.active;
    return (
      <aside id="qq-nav-rail" aria-label="主导航">
        <button type="button" className="qq-rail-avatar" title={this.props.title}
          onClick={() => this.props.onNavigate('edit')}>
          <LetterTile
            authorizeURL={this.props.tinode.authorizeURL}
            avatar={avatar}
            title={this.props.title}
            topic={this.props.myUserId} />
        </button>

        <nav className="qq-rail-nav">
          <button type="button" title="消息" aria-label="消息"
            className={'qq-rail-button' + (active === 'messages' ? ' active' : '')}
            onClick={() => this.props.onNavigate('contacts')}>
            <i className="material-icons">chat_bubble</i>
            {this.props.unread > 0 ?
              <span className="qq-rail-unread">{this.props.unread > 99 ? '99+' : this.props.unread}</span> :
              null}
          </button>
          <button type="button" title="联系人" aria-label="联系人"
            className={'qq-rail-button' + (active === 'contacts' ? ' active' : '')}
            onClick={() => this.props.onNavigate('people')}>
            <i className="material-icons">people_alt</i>
          </button>
          <button type="button" title="我" aria-label="我"
            className={'qq-rail-button' + (active === 'me' ? ' active' : '')}
            onClick={() => this.props.onNavigate('edit')}>
            <i className="material-icons">person</i>
          </button>
        </nav>

        <div className="qq-rail-bottom">
          <button type="button" title="发起聊天" aria-label="发起聊天"
            className="qq-rail-button" onClick={this.props.onNewTopic}>
            <i className="material-icons">add</i>
          </button>
          <button type="button" title="设置" aria-label="设置"
            className="qq-rail-button" onClick={this.props.onSettings}>
            <i className="material-icons">settings</i>
          </button>
        </div>
      </aside>
    );
  }
}
